import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';
import { setClassNames } from 'ddc-classnames-js';

export const Error = ({ message }) => {
	const iconClasses = ['ddc-icon', 'ddc-icon-alert', 'mr-3'];
	return (
		<Alert bsStyle="info" className="d-flex">
			<i className={setClassNames(iconClasses)} aria-hidden="true" />
			<span>{message}</span>
		</Alert>
	);
};

Error.propTypes = {
	message: PropTypes.string.isRequired
};
